/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_StatsInputs */

const th_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สถิติฤดูกาลนี้`)
};

const en_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Season so far`)
};

const ja_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今シーズンの成績`)
};

const zh_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本赛季至今`)
};

const es_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que va de temporada`)
};

const pt_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporada até agora`)
};

const id_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musim ini`)
};

const fr_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saison en cours`)
};

const tl_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngayong season`)
};

const vi_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mùa này`)
};

const ko_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이번 시즌`)
};

const de_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saison bisher`)
};

const ru_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сезон на данный момент`)
};

const tr_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sezon`)
};

const it_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stagione finora`)
};

const pl_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sezon dotychczas`)
};

const uk_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сезон наразі`)
};

const hi_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सत्र में अब तक`)
};

const ar_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموسم حتى الآن`)
};

const ms_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musim setakat ini`)
};

const bn_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এ পর্যন্ত মরসুম`)
};

const zh_tw2_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本球季至今`)
};

const zh_hk2_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本球季至今`)
};

const ur_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اب تک کا سیزن`)
};

const fa_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فصل تا اینجا`)
};

const sw_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Msimu hadi sasa`)
};

const nl_player_stats = /** @type {(inputs: Player_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seizoen tot nu toe`)
};

/**
* | output |
* | --- |
* | "Season so far" |
*
* @param {Player_StatsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_stats = /** @type {((inputs?: Player_StatsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_StatsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_stats(inputs)
	if (locale === "ja") return ja_player_stats(inputs)
	if (locale === "zh") return zh_player_stats(inputs)
	if (locale === "es") return es_player_stats(inputs)
	if (locale === "pt") return pt_player_stats(inputs)
	if (locale === "id") return id_player_stats(inputs)
	if (locale === "fr") return fr_player_stats(inputs)
	if (locale === "tl") return tl_player_stats(inputs)
	if (locale === "vi") return vi_player_stats(inputs)
	if (locale === "ko") return ko_player_stats(inputs)
	if (locale === "de") return de_player_stats(inputs)
	if (locale === "ru") return ru_player_stats(inputs)
	if (locale === "tr") return tr_player_stats(inputs)
	if (locale === "it") return it_player_stats(inputs)
	if (locale === "pl") return pl_player_stats(inputs)
	if (locale === "uk") return uk_player_stats(inputs)
	if (locale === "hi") return hi_player_stats(inputs)
	if (locale === "ar") return ar_player_stats(inputs)
	if (locale === "ms") return ms_player_stats(inputs)
	if (locale === "bn") return bn_player_stats(inputs)
	if (locale === "zh-TW") return zh_tw2_player_stats(inputs)
	if (locale === "zh-HK") return zh_hk2_player_stats(inputs)
	if (locale === "ur") return ur_player_stats(inputs)
	if (locale === "fa") return fa_player_stats(inputs)
	if (locale === "sw") return sw_player_stats(inputs)
	if (locale === "nl") return nl_player_stats(inputs)
	return en_player_stats(inputs)
});